import { createSlice } from "@reduxjs/toolkit";
// this code for slice value for Add  trade setup
export const TreadSetup = createSlice({
  name: "AddTreadSetup",
  initialState: {
    api_completed: false,
    isLoading: false,
    isSuccess: false,
    isFirst: true,
    switchResponse: false,
    data: [],
  },
  reducers: {
    add_AddTreadSetup: (state, _) => {
      state.isLoading = true;
    },
    success_api_call_add_AddTreadSetup: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
      state.api_completed = true;
      state.isFirst = true;
      state.switchResponse = true;
    },
    failure_api_call_add_AddTreadSetup: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      state.isSuccess = false;
      state.api_completed = true;
      state.switchResponse = true;
    },
    add_AddTreadSetup_is_success: (state, action) => {
      state.isSuccess = false;
    },
    create_AddTreadSetup_complete_api: (state, action) => {
      state.api_completed = false;
    },
    clear_add_Data: (state) => {
      state.data = [];
    },
    false_switchTreadSetupadd_response: (state) => {
      state.switchResponse = false;
    },
  },
});
export default TreadSetup.reducer;
export const {
  add_AddTreadSetup,
  success_api_call_add_AddTreadSetup,
  failure_api_call_add_AddTreadSetup,
  create_AddTreadSetup_complete_api,
  add_AddTreadSetup_is_success,
  clear_add_Data,
  false_switchTreadSetupadd_response
} = TreadSetup.actions;
